const state = {
    benchmarkIsLoading: false,
    pillarTranslations: {}
};

const mutations = {
    SET_BENCHMARK_IS_LOADING: async (state, benchmarkIsLoading) => {
        Vue.set(state, "benchmarkIsLoading", benchmarkIsLoading);
    },
    SET_PILLAR_TRANSLATIONS: async (state, pillarTranslations) => {
        Vue.set(state, "pillarTranslations", pillarTranslations);
    },
};

const getters = {
    GET_BENCHMARK_IS_LOADING: (state) => state.benchmarkIsLoading,
    GET_PILLAR_TRANSLATIONS: (state) => state.pillarTranslations,
};

export default {
    state,
    mutations,
    getters
}